export default "__VITE_ASSET__CAN6AA_S__"